import React, { useCallback, useEffect, useState } from "react";
import "../assets/css/mainpage.css";
import Table from "../components/table/Table";

import Alert from "../components/alert";
import { useHistory } from "react-router-dom";
import CustomSelect from "../components/select";
import config from "../api/config";

import { Button, FormControlLabel, FormGroup, Switch } from "@mui/material";
import { useBreakpoints } from "react-breakpoints-hook";
//

// starting component
const ConfirmationURL = () => {
  const [url] = useState("/api/moderator/v1/searchWebUrl");

  const [loading, setLoading] = useState(false);
  const [ads, setAds] = useState([]);
  const roles = [ "Неопубликованные", "Опубликованные",];
  const [role, setRole] = useState(0);
  let {
  lg
} = useBreakpoints({
  xs: {
    min: 0,
    max: 360
  },
  sm: {
    min: 361,
    max: 960
  },
  md: {
    min: 961,
    max: 1400
  },
  lg: {
    min: 1401,
    max: null
  }
});
  const navigate = useHistory();

  // rolechanger
  const roleHandler = useCallback(async (index) => {
    setRole(index);
    setLoading(true);
    try {
      const res = await config.get(
        `${url}?isSent=${index === 0 ? false : true}`
      );
      setLoading(false);
      setAds(res.data.objectKoinot);
    } catch (error) {

    }
  }, [url]);

  useEffect(() => {
    roleHandler(0);
  }, [roleHandler]);
  const ActiveHandler = (id) => {
    config
      .post(`/api/searchWebUrl/v1/edit-active?id=${id}`)
      .then((data) => {

        roleHandler(role);
      })
      .catch((err) => {
        console.error(err?.message);
      });
  };

  // table data
  const headData = ["Название", "Ключ", "URL", "Статус"];
  const renderHead = (item, index) => <th key={index}>{item}</th>;
  // menu data
  const renderBody = (item, index) => (
    <tr key={index}>
      <td>
        <p> {item.name}</p>
      </td>
      <td className="">
        <span> {item.keywords?.length} </span>
      </td>
      <td>
        <a href={item.url} target="_blank" rel="noopener noreferrer">
          {item.url}
        </a>
      </td>
      <td>
        <Alert
          severity={item?.isSent ? "success" : "error"}
          className="my-3 text-wrap"
        >
          {lg ? (item?.isSent ? "Подтверждено" : "Не подтверждено") : ""}
        </Alert>
      </td>
      <td>
        <FormGroup>
          <FormControlLabel
            control={
              <Switch
                checked={item.active}
                color={item.active ? "info" : "error"}
                onChange={() => ActiveHandler(item.id)}
              />
            }
            label={item.active ? "активен" : "неактивен"}
          />
        </FormGroup>
      </td>
      <td>
        <Button
          onClick={() =>
            navigate.push({
              pathname: `/sendurl`,
              data: item,
            })
          }
          variant="outlined"
          style={{
            padding: "12px 22px",
            borderRadius: "40px",
            fontWeight: "bold",
          }}
        >
          Посмотреть
        </Button>
      </td>
    </tr>
  );

  return (
    <div className="">
      <div className="row py-3">
        {/* <div className="col-md-6 col-sm-12">
          <input type="text" value={search} onChange={searchHandler} />
        </div> */}
        <div className="col-md-6 col-sm-12 col-md-offset-2">
          <CustomSelect
            selVal={role}
            selItems={roles}
            type={"outlined"}
            selHandle={(e) => {
              roleHandler(e);
            }}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          {ads?.length > 0 ? (
            <Table
              headData={headData}
              renderHead={(item, index) => renderHead(item, index)}
              bodyData={ads}
              renderBody={(item, index) => renderBody(item, index)}
              // pages={total}
              // currPage={currpage}
              // changePage={pageHandler}
              loading={loading}
            />
          ) : (
            <div className="text-center">
              <h1>Нет данных</h1>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfirmationURL;
